module.exports = __webpack_public_path__ + "img/1-07.b8e5614d.svg";